<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 16.7725H13.334V18.1357H15.334V19.499H8.66699V18.1357H10.667V16.7725H4V4.5H20V16.7725ZM11.333 14.7266V16.0908H12.666V14.7266H11.333ZM5.33301 5.86328V14.0449H18.666V5.86328H5.33301Z"
      fill="currentColor"
    />
  </svg>
</template>
